import Decimal from 'decimal.js'

const SYMBOLS = { XOF: 'FCFA', XAF: 'FCFA', EUR: '€', USD: '$', GBP: '£' }

/** Convertit une valeur API (chaîne) en Decimal ; null/invalide → 0. */
export function toDecimal(value) {
  if (value === null || value === undefined || value === '') return new Decimal(0)
  try {
    return new Decimal(value)
  } catch (e) {
    return new Decimal(0)
  }
}

/** Somme exacte de montants (chaînes) — jamais de parseFloat. */
export function sumAmounts(values) {
  return values.reduce((acc, v) => acc.plus(toDecimal(v)), new Decimal(0))
}

export function currencySymbol(currency) {
  if (!currency) return ''
  return SYMBOLS[currency.toUpperCase()] || currency
}

function group(int) {
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0')
}

/**
 * Formate un montant pour l'affichage : groupes de milliers, décimales
 * seulement si elles sont significatives. La devise est ajoutée ici, l'API
 * ne la renvoie pas dans les montants.
 */
export function formatMoney(value, currency, { signed = false, withCurrency = true } = {}) {
  if (value === null || value === undefined || value === '') return '—'
  const d = value instanceof Decimal ? value : toDecimal(value)
  const negative = d.isNegative() && !d.isZero()
  const [int, dec] = d.abs().toFixed(2).split('.')
  let out = dec === '00' ? group(int) : `${group(int)},${dec}`
  if (negative) out = `−${out}`
  else if (signed && !d.isZero()) out = `+${out}`
  const symbol = withCurrency ? currencySymbol(currency) : ''
  return symbol ? `${out}\u00A0${symbol}` : out
}

export function formatNumber(value, fractionDigits) {
  if (value === null || value === undefined || value === '') return '—'
  const d = toDecimal(value)
  const fixed = fractionDigits === undefined ? d.toString() : d.toFixed(fractionDigits)
  const [int, dec] = fixed.split('.')
  return dec ? `${group(int)},${dec}` : group(int)
}

const AMOUNT_RE = /^\d+(\.\d{1,2})?$/

/**
 * Normalise une saisie ("125 000", "12,5") en chaîne décimale ("125000",
 * "12.5"). Renvoie null si la saisie n'est pas un montant valide.
 */
export function normalizeAmountInput(raw) {
  if (raw === null || raw === undefined) return null
  const s = String(raw).replace(/[\s\u00A0\u202F]/g, '').replace(',', '.')
  return AMOUNT_RE.test(s) ? s : null
}

/** Valide un montant à envoyer : deux décimales au plus, strictement positif (ou ≥ 0). */
export function validateAmount(raw, { allowZero = false } = {}) {
  const s = normalizeAmountInput(raw)
  if (s === null) return 'Montant invalide (deux décimales au plus).'
  const d = new Decimal(s)
  if (allowZero ? d.isNegative() : !d.gt(0)) {
    return allowZero ? 'Le montant ne peut pas être négatif.' : 'Le montant doit être strictement positif.'
  }
  return null
}
